module.exports = __webpack_public_path__ + "static/6Sigma_Pelotizacao-44633a11e8d78c631dc54a817da183bf.jpeg";